import { IUserdataType } from "@/types/GlobalTypes";

//Settings
export interface ISettings {
	enableSound: boolean;
	enableMusic: boolean;
	autoSubmitBet: boolean;
	autoRebet: boolean;

	enableStreaming: boolean;
	enableRotation: boolean;

	soundVolume: number;
	musicVolume: number;
}

// SETTINGS FORM

//Default settings values
const defaultSettingsState: ISettings = {
	enableSound: true,
	enableMusic: true,
	autoSubmitBet: false,
	autoRebet: false,

	enableStreaming: true,
	enableRotation: true,

	soundVolume: 50,
	musicVolume: 25
};

//Applies default settings, supposed to be replacing original this.state properties
function setDefaultSettings(stateObject: any) {
	stateObject = { ...stateObject, ...defaultSettingsState };
}

/**
 * Using LocalStorage instead of fetch post
 */
function setEnableStreamingLS(value: boolean) {
	console.log("new enableStreaming", value);

	localStorage.setItem("enableStreaming", value + "");
}

/**
 * Using LocalStorage instead of obtaining from userdata
 */
 function getEnableStreaming() {
	const enableStreaming = localStorage.getItem("enableStreaming");
	// console.log("gES", enableStreaming);

	return enableStreaming === null || enableStreaming === "true";
}

/**
 * Used in fetchUserData
 */
function applySettingProperties(mainClass: any, userdata: IUserdataType) {
	const { user } = userdata;

	const enableStreaming = getEnableStreaming();

	// Only for mobile
	if (enableStreaming) {
		if (mainClass.reloadStreaming)
			mainClass.reloadStreaming();

		window.setTimeout(() => {
			mainClass.setState({ isLoadingStreaming: false });
		}, 5000);
	}

	mainClass.setState({
		enableSound: user.enableSound,
		enableMusic: user.enableMusic,
		autoSubmitBet: user.autoSubmitBet,

		defaultEnableStreaming: enableStreaming,
		enableStreaming,

		autoRebet: user.autoRebet,
		enableRotation: user.enableRotation,
	});
}


function updateSettings(e: any): void {
	const mainClass = this;
	const userdata = mainClass.state.userdata;
	const prop = e.currentTarget.getAttribute("prop");
	let currentValue: any;

	switch (prop) {
		case "sound": currentValue = mainClass.state.enableSound; break;
		case "music": currentValue = mainClass.state.enableMusic; break;
		case "autoSubmitBet": currentValue = mainClass.state.autoSubmitBet; break;
		case "streaming": currentValue = mainClass.state.enableStreaming; break;

		case "autoRebet": currentValue = mainClass.state.autoRebet; break;
		case "rotation": currentValue = mainClass.state.enableRotation; break;

		case "soundVolume":
			currentValue = e.target.value;
			break;
		case "musicVolume":
			currentValue = e.target.value;
			break;

		default: console.log("Unknown settings prop: " + prop); return;
	}

	if (prop === "streaming") {
		const newValue = !currentValue;

		setEnableStreamingLS(newValue);

		if (newValue) {
			mainClass.setState({ isLoadingStreaming: true });

			window.setTimeout(() => {
				mainClass.setState({ isLoadingStreaming: false });
			}, 5000);
		}

		mainClass.setState({
			defaultEnableStreaming: newValue,
			enableStreaming: newValue
		}, () => {
			mainClass.reloadStreaming();
		});

		return;
	}

	//Temporary data
	if (mainClass.state.useTempData)
		switch (prop) {
			case "sound":
				mainClass.setState({ enableSound: !currentValue });
				return;

			case "music":
				mainClass.setState({ enableMusic: !currentValue }, () => {
					if (mainClass.state.enableMusic)
						mainClass.playBGM();
					else mainClass.bgmLobby.pause();
				});
				return;

			case "autoSubmitBet":
				mainClass.setState({ autoSubmitBet: !currentValue });
				return;

			case "autoRebet":
				mainClass.setState({ autoRebet: !currentValue });
				return;

			case "rotation":
				mainClass.setState({ enableRotation: !currentValue }, () => {
					if ("updateStreamClass" in mainClass)
						mainClass.updateStreamClass();
				});
				return;


			case "soundVolume":
				mainClass.setState({ soundVolume: currentValue });
				return;

			case "musicVolume":
				//Note: always set BGM volume after update BGM volume setting
				mainClass.setState({ musicVolume: currentValue }, () => {
					mainClass.bgmLobby.volume = mainClass.state.musicVolume / 100;
				});
				return;

			default: return;
		}

	//Actual data
	interface IDataType {
		nickname: string;
		operatorId: string;
		properties: string;
		status: boolean;

		volume?: number;
	}

	const data: IDataType = {
		nickname: userdata.user.nickname,
		operatorId: userdata.user.operatorId,

		properties: prop,
		status: false,
	};

	//console.log("uS data", data);

	//Only for toggles
	const paramObj: any = {
		credentials: "same-origin",
		method: "POST",
		headers: {
			"Accept": "application/json",
			"Content-Type": "application/json"
		},

		//default props
		body: "",
	};

	switch (prop) {
		case "sound":
		case "music":
			data.status = !currentValue;
			paramObj.body = JSON.stringify(data);

			fetch("/auth/setting-sound/update", paramObj)
				.then((res: { json: () => any; }) => res.json())
				.catch((error: any) => {
					mainClass.setState({ showErrorPage: true, errorType: "lostauth", errorMessage: "" });
					return console.error(error);
				})
				.then((_data: { status: any; }) => {
					if (_data.status)
						switch (prop) {
							case "sound":
								mainClass.setState({ enableSound: !currentValue });
								break;
							case "music":
								mainClass.setState({ enableMusic: !currentValue }, () => {
									//Pauses/plays music according to the current state
									if (mainClass.state.enableMusic)
										mainClass.playBGM();
									else mainClass.bgmLobby.pause();
								});
								break;
							default: return;
						}
				});
			break;

		case "autoSubmitBet":
			data.status = !currentValue;
			paramObj.body = JSON.stringify(data);

			fetch("/auth/auto-confirm-bet/update", paramObj)
				.then((res: { json: () => any; }) => res.json())
				.catch((error: any) => {
					mainClass.setState({ showErrorPage: true, errorType: "lostauth", errorMessage: "" });
					return console.error(error);
				})
				.then((_data: { status: any; }) => {
					if (_data.status)
						mainClass.setState({ autoSubmitBet: !currentValue });
				});
			break;

		// case "streaming":
			// paramObj.body = JSON.stringify(data);

			// fetch("/auth/setting-streaming/update", paramObj)
			// 	.then((res: { json: () => any; }) => res.json())
			// 	.catch((error: any) => {
			// 		mainClass.setState({ showErrorPage: true, errorType: "lostauth", errorMessage: "" });
			// 		return console.error(error);
			// 	})
			// 	.then((_data: any) => {
			// 		if (_data.status)
			// 			mainClass.setState({
			// 				defaultEnableStreaming: !currentValue,
			// 				enableStreaming: !currentValue
			// 			}, () => {
			// 				if ("updateStreamClass" in mainClass)
			// 					mainClass.updateStreamClass();
			// 			});
			// 	});
			// break;

		case "autoRebet":
			data.status = !currentValue;
			paramObj.body = JSON.stringify(data);

			fetch("/auth/auto-rebet/update", paramObj)
				.then((res: { json: () => any; }) => res.json())
				.catch((error: any) => {
					mainClass.setState({ showErrorPage: true, errorType: "lostauth", errorMessage: "" });
					return console.error(error);
				})
				.then((_data: any) => {
					if (_data.status)
						mainClass.setState({ autoRebet: !currentValue });
				});
			break;

		case "rotation":
			data.status = !currentValue;
			paramObj.body = JSON.stringify(data);

			fetch("/auth/enable-rotation/update", paramObj)
				.then((res: { json: () => any; }) => res.json())
				.catch((error: any) => {
					mainClass.setState({ showErrorPage: true, errorType: "lostauth", errorMessage: "" });
					return console.error(error);
				})
				.then((_data: any) => {
					if (_data.status)
						mainClass.setState({ enableRotation: !currentValue });
				});
			break;

		//auth/setting-volume/:data, properties:sound/music
		//data: operatorid, user, properties, volume
		case "musicVolume":
		case "soundVolume":
			data.properties = prop.replace("Volume", "");
			data.volume = currentValue / 100;

			const request = new Request("/auth/setting-volume/update");
			const init: RequestInit = {
				credentials: "same-origin",
				method: "POST",
				headers: {
					"Accept": "application/json",
					"Content-Type": "application/json"
				},
				body: JSON.stringify(data)
			};

			switch (prop) {
				case "musicVolume":
					//Note: always set BGM volume after update BGM volume setting
					mainClass.setState({ musicVolume: currentValue }, () => {
						mainClass.bgmLobby.volume = mainClass.state.musicVolume / 100;
					});

					//Delays sending new state to the server to prevent server overloading
					if (mainClass.musicTimeout)
						window.clearTimeout(mainClass.musicTimeout);

					mainClass.musicTimeout = window.setTimeout(() => {
						fetch(request, init)
							.then((res: { json: () => any; }) => res.json())
							.catch((error: any) => {
								mainClass.setState({ showErrorPage: true, errorType: "lostauth", errorMessage: "" });
								return console.error(error);
							})
							.then((_data: any) => {
								console.log("a sv u mV dat", { data: _data });
							});
					}, 1000);
					break;

				case "soundVolume":
					mainClass.setState({ soundVolume: currentValue });

					//Delays sending new state to the server to prevent server overloading
					if (mainClass.soundTimeout)
						window.clearTimeout(mainClass.soundTimeout);

					mainClass.soundTimeout = window.setTimeout(() => {
						fetch(request, init)
							.then((res: { json: () => any; }) => res.json())
							.catch((error: any) => {
								mainClass.setState({ showErrorPage: true, errorType: "lostauth", errorMessage: "" });
								return console.error(error);
							})
							.then((_data: any) => {
								console.log("a sv u sV dat", { data: _data });
							});
					}, 1000);
					break;

				default: break;
			}
			break;

		default: return;
	}
}

export interface ISoundVolumeResponseDataType {
	volumeMusic: string;
	volumeSound: string;
}

export {
	defaultSettingsState,

	// Functions
	setDefaultSettings, applySettingProperties as setSettingProperties, updateSettings
}